import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "protocol-gateway-detail" }
const _hoisted_2 = { class: "detail-header" }
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = { style: {"margin-top":"24px"} }
const _hoisted_6 = { style: {"text-align":"center","padding":"32px 0"} }
const _hoisted_7 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_8 = {
  key: 0,
  style: {"margin-bottom":"24px"}
}
const _hoisted_9 = { style: {"text-align":"right","margin-top":"24px"} }

import { ref, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import { protocolDataList, type ProtocolRecord } from '@/data/protocolData'
import { generateServiceStatus, type ServiceStatus } from '@/mock/protocolServiceMock'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProtocolGatewayDetail',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const showEdit = ref(false)
const pointInput = ref('')
const pointList = ref<string[]>([])

const protocolCode = ref('')
const currentProtocol = ref<ProtocolRecord | undefined>(undefined)
const serviceStatusData = ref<ServiceStatus[]>([])

onMounted(() => {
  const code = route.params.code as string;
  if (code) {
    protocolCode.value = code;
    currentProtocol.value = protocolDataList.find(p => p.code === code);
    if (currentProtocol.value) {
      // 生成1到5条模拟服务状态数据
      const count = Math.floor(Math.random() * 5) + 1; 
      serviceStatusData.value = generateServiceStatus(count);
    } else {
      message.error('未找到对应的协议信息');
      // router.back(); // 可以选择返回上一页或显示错误信息
    }
  } else {
    message.error('协议Code未提供');
    // router.back();
  }
});

const protocolInfo = computed(() => {
  if (currentProtocol.value) {
    return [
      { label: '协议名称', value: currentProtocol.value.name },
      { label: '协议code', value: currentProtocol.value.code },
      { label: '协议类型', value: currentProtocol.value.type },
      { label: 'etcdKey', value: currentProtocol.value.etcdKey },
      { label: '协议服务端点', value: '-' }, // 假设服务端点暂时为'-'
      { label: '描述', value: currentProtocol.value.trans, span: 3 }, // 使用trans字段作为描述
    ];
  }
  return [];
});

function handleAddPoint() {
  if (!pointInput.value || !pointInput.value.trim()) {
    message.warning('Point不能为空')
    return
  }
  pointList.value.push(pointInput.value.trim())
  pointInput.value = ''
}
const columns = [
  { title: 'ID', dataIndex: 'id', key: 'id' },
  { title: 'IP地址', dataIndex: 'ip', key: 'ip' },
  { title: '端口', dataIndex: 'port', key: 'port' },
  {
    title: '服务状态',
    dataIndex: 'status',
    key: 'status',
    slots: { customRender: 'status' },
  },
  { title: '更新时间', dataIndex: 'updateTime', key: 'updateTime' },
  { title: '首次加入时间', dataIndex: 'joinTime', key: 'joinTime' },
  {
    title: '操作',
    key: 'action',
    slots: { customRender: 'action' },
  },
];

function goBack() {
  router.back()
}

const handleServiceAction = (action: string, record: ServiceStatus) => {
  message.info(`对服务 ${record.id} 执行 ${action} 操作`);
  // 这里可以添加实际的操作逻辑，例如调用API
  // 为了演示，我们简单地更新状态或模拟异步操作
  if (action === '重启') {
    record.status = '运行中';
  } else if (action === '停止') {
    record.status = '已停止';
  } else if (action === '启动') {
    record.status = '运行中';
  }
  // 强制刷新表格，如果状态更新不是响应式的
  serviceStatusData.value = [...serviceStatusData.value];
};


return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_tag, {
              color: "#1677ff",
              style: {"font-size":"16px"}
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("协议详情")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_button, {
              onClick: goBack,
              type: "default"
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("返回")
              ])),
              _: 1
            }),
            _createVNode(_component_a_button, {
              type: "default",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showEdit.value = true))
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("编辑")
              ])),
              _: 1
            })
          ])
        ]),
        (currentProtocol.value)
          ? (_openBlock(), _createBlock(_component_a_descriptions, {
              key: 0,
              bordered: "",
              column: 4,
              size: "middle",
              title: "协议信息"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(protocolInfo.value, (item) => {
                  return (_openBlock(), _createBlock(_component_a_descriptions_item, {
                    key: item.label,
                    label: item.label,
                    span: item.span
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.value), 1)
                    ]),
                    _: 2
                  }, 1032, ["label", "span"]))
                }), 128))
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_a_empty, {
              key: 1,
              description: "协议信息加载中或未找到..."
            })),
        _createElementVNode("div", _hoisted_5, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { style: {"font-weight":"bold","margin-bottom":"8px"} }, "服务状态", -1)),
          _createVNode(_component_a_table, {
            columns: columns,
            "data-source": serviceStatusData.value,
            pagination: false,
            style: {"margin-top":"8px"}
          }, {
            status: _withCtx(({ text: status }) => [
              _createVNode(_component_a_tag, {
                color: status === '运行中' ? 'green' : status === '已停止' ? 'red' : 'orange'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(status), 1)
                ]),
                _: 2
              }, 1032, ["color"])
            ]),
            action: _withCtx(({ record }) => [
              _createVNode(_component_a_space, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "link",
                    size: "small",
                    onClick: ($event: any) => (handleServiceAction('重启', record)),
                    disabled: record.status !== '已停止' && record.status !== '异常'
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("重启")
                    ])),
                    _: 2
                  }, 1032, ["onClick", "disabled"]),
                  _createVNode(_component_a_button, {
                    type: "link",
                    size: "small",
                    onClick: ($event: any) => (handleServiceAction('停止', record)),
                    disabled: record.status !== '运行中'
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("停止")
                    ])),
                    _: 2
                  }, 1032, ["onClick", "disabled"]),
                  _createVNode(_component_a_button, {
                    type: "link",
                    size: "small",
                    onClick: ($event: any) => (handleServiceAction('启动', record)),
                    disabled: record.status === '运行中'
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("启动")
                    ])),
                    _: 2
                  }, 1032, ["onClick", "disabled"])
                ]),
                _: 2
              }, 1024)
            ]),
            emptyText: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_a_empty, { description: "暂无数据" })
              ])
            ]),
            _: 1
          }, 8, ["data-source"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      open: showEdit.value,
      "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((showEdit).value = $event)),
      title: "编辑",
      width: "900px",
      footer: null,
      closable: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "协议名称",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: "联犀MQTT协议",
                  readonly: ""
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "etcdKey" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: "dg.rpc",
                  readonly: ""
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "point",
              style: {"margin-bottom":"8px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_a_input, {
                    value: pointInput.value,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((pointInput).value = $event)),
                    placeholder: "请输入point",
                    style: {"width":"300px","margin-right":"8px"}
                  }, null, 8, ["value"]),
                  _createVNode(_component_a_button, {
                    type: "dashed",
                    onClick: handleAddPoint
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("新增")
                    ])),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            (pointList.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pointList.value, (item, idx) => {
                    return (_openBlock(), _createBlock(_component_a_tag, {
                      key: item + idx,
                      closable: "",
                      onClose: ($event: any) => (pointList.value.splice(idx, 1)),
                      style: {"margin-right":"8px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClose"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_form_item, { label: "协议描述" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  placeholder: "请输入协议描述",
                  rows: "3"
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_a_button, {
                style: {"margin-right":"8px"},
                onClick: _cache[2] || (_cache[2] = ($event: any) => (showEdit.value = false))
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode("取消")
                ])),
                _: 1
              }),
              _createVNode(_component_a_button, { type: "primary" }, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createTextVNode("确定")
                ])),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})